import CloneVoice from '@/images/CloneVoice.svg';
import FaceFemale from '@/images/FaceFemale.svg';
import FaceMale from '@/images/FaceMale.svg';
import Gender from '@/images/Gender.svg';
import { ttsVoiceGenderFilter } from '@/state/presenters';
import { GENDER } from '@d-id/tts';
import { SelectChangeEvent } from '@mui/material/Select';
import { useRecoilState } from 'recoil';
import { FilterChipSelect, FilterOption } from './FilterChipSelect';

const defaultOption = { value: 'all', label: 'All', chipLabel: 'Gender', icon: Gender };

const genderOptions: FilterOption[] = [
    defaultOption,
    { value: GENDER.MALE, label: 'Male', icon: FaceMale },
    { value: GENDER.FEMALE, label: 'Female', icon: FaceFemale },
    { value: GENDER.NON_BINARY, label: 'Non-Binary', icon: CloneVoice },
];
export const GenderChipSelect = () => {
    const [ttsVoiceGenderFilterValue, setTtsVoiceGenderFilter] = useRecoilState(ttsVoiceGenderFilter);

    const handleChange = (e: SelectChangeEvent<string>) => {
        const value = (genderOptions.find(o => o.value === e.target.value)?.value as GENDER) || defaultOption.value;

        setTtsVoiceGenderFilter(value);
    };

    const option = genderOptions.find(option => option.value === ttsVoiceGenderFilterValue) || defaultOption;

    return (
        <FilterChipSelect
            data-testid="voice-gender-filter"
            id="gender-filter"
            variant="outlined"
            value={option}
            options={genderOptions}
            onChange={handleChange}
        />
    );
};
